import React from 'react';
import { FilterSideMenu } from '@/modules/shared/FilterSideMenu';
import { useNavigate } from 'react-router-dom';
import SettingsItemCard from '@/components/pages/SettingsPage/SidePane/SettingsItemCard';
import { getDefaultSelectedMenuItem } from '@/components/pages/SettingsPage/SidePane/utils';
import { useUserData } from '@/components/pages/SettingsPage/MainContent/shared/useUserData';
import { MANAGEMENT_ROLE } from '@/const';
import { CircleUserIcon, SlidersIcon, UserGroupIcon } from '@/assets/Icons';
import { Icon } from '@/components/shared/display/Icon';

export const SettingsSidePane = () => {
  const { userData } = useUserData();
  const navigate = useNavigate();

  const filterSideMenuItems = [
    {
      menuLabel: 'settings',
      menuItems: [
        {
          id: 'account-settings',
          name: 'Account Settings',
          location: 'account',
          icon: () => <Icon icon={CircleUserIcon} />,
          hidden: false,
        },
        {
          id: 'user-management',
          name: 'User Management',
          location: 'users',
          icon: () => <Icon icon={UserGroupIcon} />,
          hidden: ![MANAGEMENT_ROLE.DM_Admin, MANAGEMENT_ROLE.Admin].includes(userData?.role),
        },
        {
          id: 'notification-preferences',
          name: 'Notification Preferences',
          location: 'notification-preferences',
          icon: () => <Icon icon={SlidersIcon} />,
          hidden: ![MANAGEMENT_ROLE.DM_Admin, MANAGEMENT_ROLE.Admin].includes(userData?.role),
        },
        {
          id: 'application-preferences',
          name: 'Preferences',
          location: 'application-preferences',
          icon: () => <Icon icon={SlidersIcon} />,
          hidden: ![MANAGEMENT_ROLE.DM_Admin].includes(userData?.role),
        },
      ],
    },
  ];

  const items = filterSideMenuItems.map((section) => ({
    ...section,
    menuItems: section.menuItems.filter((item) => !item.hidden),
  }));

  const onItemClick = (item: any) => {
    const location = item.location || item.menuItems?.find((mi: any) => mi.location)?.location;
    if (location) navigate(`/settings/${location}`);
  };

  return (
    <div className="h-full w-full max-h-full overflow-hidden">
      <FilterSideMenu
        variant="maintenance"
        title=" "
        renderItemsCard={(item: any) => <SettingsItemCard name={item.name} icon={item.icon} />}
        items={items}
        defaultSelected={{ settings: [getDefaultSelectedMenuItem()] }}
        onFilterChange={() => void 0}
        onClick={onItemClick}
      />
    </div>
  );
};
